import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';

import { DynamicSchemaDefinitionToggle } from '../../../../../graphql/generated/graphql';
import Base from './Base';

interface Props {
  field: Pick<DynamicSchemaDefinitionToggle, 'label' | 'checkedControlLabel' | 'uncheckedControlLabel'>;
  value: boolean;
  className?: string;
}

const AsToggle = ({ field, value, className }: Props & ClassAttributes<HTMLElement>) => {
  const label = value ? field.checkedControlLabel : field.uncheckedControlLabel;

  return (
    <Base field={field} className={className}>
      <Typography variant="body1">{label}</Typography>
    </Base>
  );
};

export default AsToggle;
